var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKycQuetionMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5581_1275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.931519C5.36761 0.931519 0 6.29852 0 12.9315C0 19.5638 5.367 24.9315 12 24.9315C18.6324 24.9315 24 19.5645 24 12.9315C24 6.29913 18.633 0.931519 12 0.931519ZM12 23.2571C6.30647 23.2571 1.67442 18.6251 1.67442 12.9315C1.67442 7.23794 6.30647 2.60594 12 2.60594C17.6936 2.60594 22.3256 7.23794 22.3256 12.9315C22.3256 18.6251 17.6936 23.2571 12 23.2571Z",
    fill: "#4F5153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6449 16.1154C10.9815 16.1154 10.4445 16.6683 10.4445 17.3317C10.4445 17.9793 10.9657 18.548 11.6449 18.548C12.3241 18.548 12.8611 17.9793 12.8611 17.3317C12.8611 16.6683 12.3083 16.1154 11.6449 16.1154Z",
    fill: "#4F5153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8503 6.90662C9.71784 6.90662 8.73853 8.17032 8.73853 9.02326C8.73853 9.63929 9.25978 9.92363 9.68624 9.92363C10.5392 9.92363 10.1917 8.70732 11.8029 8.70732C12.5926 8.70732 13.2245 9.05485 13.2245 9.78146C13.2245 10.6344 12.3399 11.1241 11.8187 11.5663C11.3606 11.9611 10.7604 12.6088 10.7604 13.9673C10.7604 14.7886 10.9815 15.0256 11.6291 15.0256C12.4031 15.0256 12.561 14.6781 12.561 14.3779C12.561 13.5565 12.5768 13.0827 13.4456 12.4035C13.8721 12.0718 15.2147 10.9976 15.2147 9.51287C15.2147 8.0281 13.8721 6.90662 11.8503 6.90662Z",
    fill: "#4F5153"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5581_1275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.931519)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycQuetionMark);
export default __webpack_public_path__ + "static/media/KycQuetionMark.5965135bda10a364c370aa90718f5858.svg";
export { ForwardRef as ReactComponent };